import React, { Component } from "react";
import { Container, Table, Row } from "react-bootstrap";
import Filter from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import TableSizePopup from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import { SeatingStatus } from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";

import moment from "moment";
import {
  EventTableManagementHeadRight,
  OfflineEventTableHead,
} from "./OfflineEventTableHead";
import OfflineEventTableBody from "./OfflineEventTableBody";
import Pagination from "rc-pagination";
import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import AllActionPopup from "../AllActionPopup/AllActionPopup";
import LocationReusable from "../../../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import CallingButtonPopup from "../../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import { SendSmsButton } from "../../../../../reusableComponents/allPopupReusable/SendSmsButton";
import { NotificationButton } from "../../../../../reusableComponents/allPopupReusable/NotificationButton";
import { PopupIconButtonReusable } from "../../../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import { ViewButtonPopup } from "../../../../../reusableComponents/allPopupReusable/ViewButtonPopup";
import isEmpty from "../../../../../../store/validation/is-Empty";

import RsvpSetWaitTime from "../AllActionPopup/RsvpSetWaitTime";
// import TableManagementBodyRight from "../../../seatingDashboard/seatingDashboard/TableManagementBodyRight";
// import ChatWindow from "../../../seatingDashboard/seatingDashboard/ChatWindow";

class OfflineEventDetailsMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayGrid: false,
      displayDropDown: false,
      currentPagination: 1,
      allDinerDetails: [],
      displayMobileSearch: false,
      displaySearch: false,
      open: false,
      openDefaultWaitTime: false,
      openPax: false,
      selectedPage: 1,
      showStatus: "All",
      showStatusText: "",
      defaultWaitTime: "00-05",
      showPax: "All",
      showPaxText: "",
      search: "",
      chat: false,
      pendingEventData: [],
      fullScreen: false,
      tableSelected: {},
    };
    this.chatRef = React.createRef();
  }

  setTableSelected = (table) => {
    this.setState({ tableSelected: table });
  };

  componentDidMount() {
    if (!isEmpty(this.props.pendingData)) {
      this.setState({
        pendingEventData: isEmpty(this.props.pendingData)
          ? this.props.pendingData
          : [],
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.pendingData !== nextState.pendingEventData) {
      return {
        pendingEventData: !isEmpty(nextProps.pendingData)
          ? nextProps.pendingData
          : [],
      };
    } else {
      return null;
    }
  }

  onNextHoursOpen = (e) => {
    this.setState({
      displayDropDown: !this.state.displayDropDown,
    });
  };

  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  /***************************************************
   * @DESC Desktop View Table Design
   ***************************************************/
  renderDesktopTableBody = () => {
    const { pendingEventData, showPax } = this.state;
    let filtereddata = [];
    if (showPax === "All") {
      filtereddata = pendingEventData;
    } else if (showPax === "8>") {
      filtereddata = pendingEventData.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (showPax === "8") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "6") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "4") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "2") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = pendingEventData.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else if (search.test(getall.event_request_id)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map((data, index) => (
        <React.Fragment key={index}>
          <OfflineEventTableBody
            tableSelected={this.state.tableSelected}
            displayGrid={!this.state.displayGrid}
            dinerInfo={data}
            dinerName={data}
            displayCall={true}
            displaySms={true}
            displayNotification={true}
            displayChat={true}
            displayViewDiner={true}
            displayEditDiner={true}
            pathname={this.props.pathname}
            sendDataDinerProps={data}
            openChatWindow={this.openChatWindow(data, "event")}
          />
        </React.Fragment>
      ));
    }
  };

  openChatWindow = (data, actionBy) => (e) => {
    this.chatRef.current.openNav(data, actionBy);
  };

  /***************************************
   * @DESC Mobile View Component
   ***************************************/
  renderRSVPAccordian = () => {
    const { pendingEventData, showPax } = this.state;
    let filtereddata = [];
    if (showPax === "All") {
      filtereddata = pendingEventData;
    } else if (showPax === "8>") {
      filtereddata = pendingEventData.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (showPax === "8") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "6") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "4") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (showPax === "2") {
      filtereddata = pendingEventData.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = pendingEventData.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else if (search.test(getall.event_request_id)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map((data, index) => (
        <React.Fragment key={index}>
          <RSVPMobileTableBody eventData={data} index={index} />
        </React.Fragment>
      ));
    }
  };
  onGridViewOpen = () => {
    this.setState({ displayGrid: !this.state.displayGrid });
  };

  setTableSelected = (table) => {
    this.setState({ tableSelected: table });
  };

  handleFullScreen = () => {
    if (this.state.fullScreen) {
      this.setTableSelected({});
    }
    this.setState({ fullScreen: !this.state.fullScreen });
  };

  render() {
    const { displayGrid, displayDropDown, fullScreen, chat } = this.state;
    const { pathname } = this.props;
    return (
      <React.Fragment>
        {/* <ChatWindow ref={this.chatRef} /> */}
        <Row className="container-fluid">
          <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 seating-topbar-search">
            <div className="filter-button">
              <Filter origin={"events"} />
            </div>
            <div className="filter-button-border-left"></div>
            <div className="filter-button-search">
              <Paper component="form" className="enSearch2 d-flex">
                <IconButton type="submit" aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  placeholder="Search"
                  className="w-100"
                  inputProps={{
                    "aria-label": "Search by Name or Phone Number",
                  }}
                  onChange={this.onSearchChange}
                  value={this.state.search}
                />
              </Paper>
            </div>
            <div className="filter-button-qrcode">
              <div className="filter-button-qrcode-box">
                <img
                  src={require("../../../../../../assets/images/ActionImages/image/qrcode.svg")}
                  className="img-fluid"
                  alt="QR Scan"
                  title="QR Scan"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <div className="row">
              <div className="col-4 col-sm-4 col-md-4 col-lg-4 ">
                <SeatingStatus
                  status={this.state.showStatus}
                  onOpenModal={this.onOpenModal}
                  onCloseModal={this.onCloseModal}
                  open={this.state.open}
                  eventsMoreOptions={
                    this.props.pathname === "/offline-events-details"
                      ? true
                      : false
                  }
                  //   seatingStatus={this.state.showStatusText}
                  //   onClickAll={(e) => this.bigButtonShowStatusHandler(e, "All")}
                  //   onClickSeated={(e) =>
                  //     this.bigButtonShowStatusHandler(e, "Seated")
                  //   }
                  //   onClickNonSeated={(e) =>
                  //     this.bigButtonShowStatusHandler(e, "Not Seated")
                  //   }
                  //   onStatusClick={this.selectStatusClick}
                />
              </div>
              {this.props.markSeatedDisplay === "Pending" ||
              this.props.markSeatedDisplay === "TicketBooked" ? null : (
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 ">
                  <RsvpSetWaitTime eventSetTime={this.props.dataProps} />
                </div>
              )}
              <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                <TableSizePopup
                  showPax={this.state.showPax}
                  onOpenModal={this.onOpenModalPax}
                  open={this.state.openPax}
                  onCloseModal={this.onCloseModalPax}
                  table_size={this.state.showPaxText}
                  onClickAll={(e) => this.bigButtonShowPaxHandler(e, "All")}
                  onClickTwo={(e) => this.bigButtonShowPaxHandler(e, "2")}
                  onClickFour={(e) => this.bigButtonShowPaxHandler(e, "4")}
                  onClickSix={(e) => this.bigButtonShowPaxHandler(e, "6")}
                  onClickEight={(e) => this.bigButtonShowPaxHandler(e, "8")}
                  graterThanEight={(e) => this.bigButtonShowPaxHandler(e, "8>")}
                  selectPaxClick={this.selectPaxClick}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 right-side-seating mobile-d-flex mobile-justify-content-between ">
            {this.props.markSeatedDisplay !== "Pending" ? (
              <div className="complete_record_image">
                <AllActionPopup
                  display={true}
                  displayPopup="completedRecord"
                  buttonDisplay="completedRecord"
                  buttonText="Complete Record"
                  bigText="Are you sure to Complete All Seated Records ?"
                  allDataProps={this.props.dataProps}
                />
                <p className="complete_record_small_text">
                  Mark Seated as Complete
                </p>
              </div>
            ) : (
              <div className="complete_record_image"></div>
            )}
            <div className="btn-group" role="group" aria-label="Basic example">
              <button
                type="button"
                className={
                  displayGrid
                    ? "btn grid-button-group"
                    : "btn grid-button-group grid-button-group-active"
                }
                onClick={this.onGridViewOpen}
              >
                <img
                  src={require("../../../../../../assets/images/ActionImages/image/grid.svg")}
                  className="img-fluid"
                  alt="table"
                  title="table"
                />
              </button>
              <button
                type="button"
                className={
                  displayGrid
                    ? "btn grid-button-group grid-button-group-active"
                    : "btn grid-button-group"
                }
                onClick={this.onGridViewOpen}
              >
                <img
                  src={require("../../../../../../assets/images/ActionImages/image/table.svg")}
                  className="img-fluid"
                  alt="table"
                  title="table"
                />
              </button>
            </div>
          </div>
        </Row>
        <Container fluid className="p-0">
          <Media query="(max-width: 992px)">
            <>
              <div className="row seating-dashboard-table ml-0 mr-0">
                <div className="col-2 mpr-1">
                  <p className="f12-700 pl-3">
                    Req. <br />
                    Type
                  </p>
                </div>
                <div className="col-4 mpl-1 mpr-1">
                  <p className="f12-700">Name/Request Number</p>
                </div>
                <div className="col-3 mpl-1">
                  <p className="f12-700">Total PAX</p>
                </div>
                <div className="col-3 mpl-1">
                  <p className="f12-700">
                    Date / Time
                    <br /> Timer
                  </p>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-12 p-0">
                  <Accordion>{this.renderRSVPAccordian()}</Accordion>
                </div>
              </div>
            </>
          </Media>
          <Media query="(min-width: 992px)">
            <div className="row mt-4">
              {!fullScreen && (
                <div
                  className={displayGrid === true ? "col-7 p-0" : "col-12 p-0"}
                >
                  <div className="col-12">
                    <div className="seating-dashboard-desktop-table">
                      <Table>
                        <OfflineEventTableHead
                          displayGridProps={displayGrid}
                          parent={"events"}
                          pathname={pathname}
                        />
                      </Table>
                    </div>
                  </div>
                  {!this.props.pathname.includes("offline-events-pending") &&
                    !this.props.pathname.includes("offline-events-booked") && (
                      <>
                        {displayGrid ? null : (
                          <div className="col-12 today-date-dropdown-seating-dashboard">
                            <div>
                              <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                            </div>
                            <div className="seating-dashboard-today-line">
                              <hr className="line" />
                            </div>
                          </div>
                        )}
                        {displayGrid ||
                        pathname === "/offline-events-history" ? null : (
                          <div className="col-12 mb-4">
                            <div className="seating-dashboard-next-hours">
                              <div
                                className="dropdown_box b_c_red"
                                onClick={this.onNextHoursOpen}
                              >
                                {displayDropDown ? (
                                  <i
                                    className="fa fa-angle-up c_white"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i
                                    className="fa fa-angle-down c_white"
                                    aria-hidden="true"
                                  ></i>
                                )}
                              </div>
                              <h5 className="font_20_m c_red ml-3">
                                With-in next hour
                              </h5>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                  <div className="col-12 seating-dashboard-body-width">
                    <Table>{this.renderDesktopTableBody()}</Table>
                  </div>
                </div>
              )}
              <div
                className={
                  displayGrid === true
                    ? fullScreen
                      ? "col-12 seating-right-side-boxcount p-0"
                      : "col-5 seating-right-side-boxcount p-0"
                    : "d-none"
                }
              >
                <div className="col-12">
                  <div className="seating-dashboard-desktop-table">
                    <Table>
                      <EventTableManagementHeadRight />
                    </Table>
                  </div>
                  {/* <div>
                    <TableManagementBodyRight
                      handleFullScreen={this.handleFullScreen}
                      tableSelected={this.state.tableSelected}
                      setTableSelected={this.setTableSelected}
                      fullScreen={this.state.fullScreen}
                      dinerInfo={this.state.pendingEventData}
                      origin="events"
                    />
                  </div> */}
                </div>
                {/* <div className="p4v2-menu-pagination">
                  <Pagination
                    //   onChange={this.onChangePagination}
                    current={1}
                    defaultPageSize={50}
                    total={10}
                    showTitle={false}
                  />
                </div> */}
              </div>
            </div>
          </Media>
        </Container>
      </React.Fragment>
    );
  }
}

export default OfflineEventDetailsMain;

class RSVPMobileTableBody extends Component {
  state = {
    show: false,
  };
  setShow = (e) => {
    this.setState({ show: e });
  };
  render() {
    const { show } = this.state;
    const { index, eventData } = this.props;
    return (
      <div>
        <SwipeableList className={`swipe`}>
          {({ swipe, ...rest }) => (
            <div className={`${show ? "swipe" : ""}`}>
              <SwipeableListItem
                swipeLeft={{
                  content: (
                    <div className="d-flex swipeOption">
                      <button
                        type="button"
                        className="n_button_d_status font_18_m "
                        // style={{ backgroundColor: "white" }}
                      >
                        <div
                          style={{
                            fontSize: "8px",
                            lineHeight: "10px",
                            color: "black",
                          }}
                        >
                          Total wait time
                        </div>
                        <br />
                        <div className="f10-400">00 hh : 20 mins</div>
                      </button>
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        buttonText="Cancel"
                        bigText="Are you sure to Cancel ?"
                        // dataSend={sendDataDinerProps._id}
                      />
                      <AllActionPopup
                        buttonDisplay="smallSaveButton"
                        displayPopup="SeatedButton"
                        buttonText="Seat"
                        bigText="Are you sure to Seated ?"
                        // dataSend={sendDataDinerProps._id}
                      />
                    </div>
                  ),
                  action: () => this.setShow(true),
                }}
                swipeRight={{
                  // content: <div>Revealed content during swipe</div>,
                  action: () => this.setShow(false),
                }}
                {...rest}
              >
                <Card className="main-reusable-accordion">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={index + 1}
                    className={`enLeftGReenLine`}
                  >
                    <div className="d-flex align-items-center">
                      <div className="card-header-left">
                        <div className="d-flex align-items-start">
                          <Image
                            src={require("../../../../../../assets/images/ActionImages/image/walkin.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image"
                          />
                          <div style={{ marginLeft: "15px" }}>
                            <p className="f10-500">
                              {eventData &&
                                eventData.user_details &&
                                eventData.user_details.name}
                            </p>
                            <p className="f9-400">
                              #{eventData && eventData.event_request_id}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card-header-middle mr-1"}
                        style={{ marginLeft: "40px" }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="total-pax">
                            <p className="f14-700 text-right">
                              {eventData &&
                                eventData.adult_count + eventData.kids_count}
                            </p>
                            <p className="f10-700">PAX</p>
                          </div>
                          <div className="total-adult-kids">
                            <div className="display-align">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/employees.png")}
                                alt="Adult"
                                title="Adult"
                                className="pax-type-Image"
                              />
                              <p className="total-count">
                                {eventData && eventData.adult_count}
                              </p>
                            </div>
                            <div className="display-align  mb-0">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/children.png")}
                                alt="Kids"
                                title="Kids"
                                className="pax-type-Image"
                              />
                              <p className="total-count">
                                {eventData && eventData.kids_count}
                              </p>
                            </div>
                          </div>
                          <div className="total-highchair-handicapp">
                            <div className="display-align">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/highchair.png")}
                                alt="Highchair"
                                title="Highchair"
                                className="pax-type-Image-highchair"
                              />
                              <p className="total-count">
                                {eventData && eventData.high_chair}
                              </p>
                            </div>
                            <div className="display-align mb-0">
                              <Image
                                src={require("../../../../../../assets/images/ActionImages/wheelchair.png")}
                                alt="Handicapped"
                                title="Handicapped"
                                className="pax-type-Image-handicapped"
                              />
                              <p className="total-count">
                                {eventData && eventData.handicap_chair}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card-header-right justify-content-center"}
                      >
                        <div className="f10-700">
                          {moment(eventData && eventData.createdAt).format(
                            "Do MMM, YYYY"
                          )}
                          <br />
                          {moment(eventData && eventData.createdAt).format(
                            "hh:mm A"
                          )}
                        </div>
                      </div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index + 1}>
                    <Card.Body>
                      {/******* Section One *********/}
                      <hr className="mt-0" />
                      <div className="row">
                        <div className="col-3 sectionone-left">
                          <p className="f10-700 pb-2 opacity5">
                            Seating Preferences
                          </p>
                          <p className="f10-400">{"Outdoor"}</p>
                        </div>
                        <div className="col-5 sectionone-middle border-right border-left">
                          <p className="f10-700 pb-2 opacity5">Date & Time</p>
                          <div className="f10-400">
                            {moment(eventData && eventData.createdAt).format(
                              "Do MMM, YYYY hh:mm A"
                            )}
                          </div>
                        </div>
                        <div className="col-4 sectionone-right">
                          <p className="f10-500 pb-2 text-blue">Track User</p>
                          <div className="box-border mobile flex-start">
                            <LocationReusable
                            // dataSend={sendDataDinerProps}
                            />
                          </div>
                        </div>
                      </div>
                      {/******* Section Two *********/}
                      <hr />
                      <div
                        className={
                          "action-section-body d-flex align-items-center justify-content-center mobile"
                        }
                      >
                        {/* {displayButton.diner_status === "NOTSEATED" ? ( */}
                        <div className="mr-2">
                          <AllActionPopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            buttonText="Cancel"
                            bigText="Are you sure to Cancel ?"
                            // dataSend={sendDataDinerProps._id}
                          />
                        </div>
                        {/* ) : null || displayButton.diner_status === "SEATED" ? (
                          <div className="mr-2">
                            <AllActionPopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Are you sure to Unseat ?"
                              // dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButton === "pendingReject" ? (
                          <div className="mr-2">
                            <AllActionPopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Reject"
                              bigText="Are you sure to Reject ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null ||
                          displayButton.diner_status === "COMPLETED" ||
                          displayButton.diner_status === "REJECTED" ? (
                          <div className="mr-2">
                            <AllActionPopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyReset"
                              buttonText="Reset"
                              bigText="Are you sure to Reset ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null} */}
                        <div className="middle-timer">
                          <p className="f9-400 text-center">Total Wait time</p>
                          <div className="enTimesLbl d-flex justify-content-center align-items-center">
                            <Image
                              alt="wait"
                              title="wait"
                              width="10px"
                              height="13px"
                              src={require("../../../../../../assets/images/UserManagement/wait.svg")}
                            />
                            <p className="f10-500 pl-1">00 hh : 20 mins</p>
                          </div>
                        </div>

                        {/* {displayButton.diner_status === "NOTSEATED" ? ( */}
                        <div className="ml-2">
                          <AllActionPopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="SeatedButton"
                            buttonText="Seat"
                            bigText="Are you sure to Seated ?"
                            // dataSend={sendDataDinerProps._id}
                          />
                        </div>
                        {/* ) : null || displayButton.diner_status === "SEATED" ? (
                          <div className="ml-2">
                            <AllActionPopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Are you sure to Completed ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButtonTwo === "pendingAccept" ? (
                          sendDataDinerProps.service_type === "RESERVATION" ? (
                            sendDataDinerProps.service_type === "RESERVATION" &&
                            date4 < date1.getTime() ? (
                              ""
                            ) : (
                              <AllActionPopup
                                buttonDisplay="smallSaveButton"
                                displayPopup="acceptButtonReservation"
                                buttonText="Accept"
                                bigText="Are you sure you want to accept ?"
                                dataSend={sendDataDinerProps}
                              />
                            )
                          ) : sendDataDinerProps.service_type === "SEATING" &&
                            date3 < date1.getDate() ? (
                            ""
                          ) : (
                            <AllActionPopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="acceptButton"
                              buttonText="Accept"
                              bigText="Are you sure you want to accept ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          )
                        ) : null} */}
                      </div>
                      {/******* Section Three *********/}
                      <hr />
                      <div className="col-12 sectionthree">
                        <div className="d-flex align-items-center justify-content-center">
                          {/* {displayCall === true ? ( */}
                          <CallingButtonPopup buttonClass="smallButton" />
                          {/* ) : null} */}
                          {/* {displaySms === true ? ( */}
                          <SendSmsButton
                            buttonClass="smallButton"
                            // dataSend={sendDataDinerProps}
                          />
                          {/* ) : null} */}
                          {/* {displayNotification === true ? ( */}
                          <NotificationButton
                            buttonClass="smallButton"
                            // dataSend={sendDataDinerProps}
                          />
                          {/* ) : null} */}
                          {/* {displayChat === true ? ( */}
                          <div className="mr-3">
                            <PopupIconButtonReusable
                              buttonClass={"bigButton"}
                              titleText="Send Sms Button"
                              image={require("../../../../../../assets/images/UserManagement/forum.svg")}
                              // onClick={this.onOpenModal}
                            />
                          </div>
                          {/* ) : null} */}
                          {/* {displayViewDiner === true ? ( */}
                          <div className="btnMobile mr-3">
                            <ViewButtonPopup
                              buttonClass="smallButton"
                              // dataSend={sendDataDinerProps}
                            />
                          </div>
                          {/* ) : null} */}
                          {/* {displayEditDiner === true &&
                          date2.getDate() < date1.getDate() ? (
                            ""
                          ) : ( */}
                          <div className="btnMobile">
                            {/* <EditDiner
                              buttonClass="smallButton"
                              bigText="Edit Diner"
                              // dataSend={sendDataDinerProps}
                            /> */}
                          </div>
                          {/* )} */}
                        </div>
                      </div>

                      {/******* Section Four *********/}
                      <hr />
                      <div className="col-12 sectionfour">
                        <div className="sectionfour-left">
                          <p className="f10-700 pb-2 opacity5">
                            Table / Room No.
                          </p>
                          <p className="f10-400">
                            Room No. - {eventData && eventData.room_number}
                          </p>
                          <p className="f10-400">
                            Table No. -
                            {eventData &&
                              eventData.seat_number.map((data, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {data},
                                  </React.Fragment>
                                );
                              })}
                          </p>
                        </div>
                        <div className="sectionfour-middle border-right border-left">
                          <p className="f10-700 pb-2 opacity5">
                            Special Occasion
                          </p>
                          <p className={`f10-400 `}>
                            {eventData && eventData.occasion}
                          </p>
                          {/* <span
                            className="f10-400 cursor text-red"
                            // onClick={textToggle}
                          >
                            See More
                          </span> */}
                        </div>
                        <div className="sectionfour-right pl-1">
                          <p className="f10-700 pb-2 opacity5">Status</p>
                          <p className="f10-700">
                            {eventData && eventData.event_status}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </SwipeableListItem>
            </div>
          )}
        </SwipeableList>
      </div>
    );
  }
}
